// extracted by mini-css-extract-plugin
export default {"main":"ButtonCross_main__D6r6C"};